import { arrayOf } from 'prop-types';
import BannerTemplatePropType from './BannerTemplatePropType';
//TODO: move to polymer
export default arrayOf(BannerTemplatePropType).isRequired;
